class VwHbsOrderKonsultasyonDTO {
    id: number = 0;
    orderDetayId?: number = 0;
    tipId?: number = 1; //parametre grup_id = 51
    tipAdi?: string = "";
    orderServisId?: number = null;
    orderDoktorId?: number = null;
    orderServisAdi?: string = "";
    orderDoktorAdi?: string = "";
    acil?: string = "H";
    istemNotu?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    aciklama?: string = "";
    hastaservisId?: number = null;
    servisId?: number = 0;
    doktorId?: number = 0;
    okundu?: string = "H";
    konsServisAdi?: string = "";
    konsDoktorAdi?: string = "";
    muracaatId?: number = null;
    rapor?: string = "";
    raporYazmaTarihi?: string = null;
    raporId?: number = null;
};
export default VwHbsOrderKonsultasyonDTO;